import { UsedBonusReportTranslations } from ".";

export const USED_BONUS_REPORT_EN_US: UsedBonusReportTranslations = {
	usedBonus: "Used Bonuses",
	columns: {
		client: "Client",
		givenAt: "Given At",
		consumedAt: "Consumed At",
		reason: "Reason",
		spentValueInBonus: "Spent Value in Bonuses",
		total: "Total",
	},
};
